import cloneDeep from 'lodash/cloneDeep'

export const findFilterById = (filters, id) => {
  return filters ? filters.find((filter) => filter.id === id) : {}
}
export const prepareFilterForChallenge = ({ filter, oldValue, exceptArray, }) => {
  if (!filter) {
    return filter
  }

  let restrictedOptions = []
  if (oldValue) {
    restrictedOptions.push(oldValue)
  }
  if (exceptArray) {
    restrictedOptions = [ ...restrictedOptions, ...exceptArray, ]
  }

  if (filter.data_type === 'RESOURCE') {
    restrictedOptions = restrictedOptions.map((item) => {
      if (item.id) {
        return item
      } else if (typeof item === 'string' || item instanceof String){
        return { id: item, }
      } else if ('code' in item) {
        item.id = item.code
      } else {
        console.error('Id is missing, prepareFilterForChallenge can\'t work as expected!')
      }
      return item
    })
  }

  let filterClone = cloneDeep(filter)
  filterClone.restrictedOptions = restrictedOptions

  return filterClone
}
export const getItemsByContext = (filters, value) => {
  if (filters) {
    const forItem = (value) => filters.reduce((acc, item) => {
      return item.contexts.includes(value) ? [ ...acc, item, ] : [ ...acc, ]
    }, [])
    return Array.isArray(value)
      ? [ ...new Set(value.reduce((acc, item) => [ ...acc, ...forItem(item), ], [])), ]
      : forItem(value)
  }
}

export const getItemsByContextAndType = ({
  filters,
  context,
  type,
}) => {
  if (filters) {
    const forItem = (context) => filters.reduce((acc, item) => {
      if (item.contexts.includes(context)){
        if (item.xpath.includes(`/${type}:`)){
          return [ ...acc, item, ]
        }
      }
      return [ ...acc, ]
    }, [])
    return Array.isArray(context)
      ? [ ...new Set(context.reduce((acc, item) => [ ...acc, ...forItem(item), ], [])), ]
      : forItem(context)
  }
}

export const getSortedBy = (sortedBy) => sortedBy.field ? `${sortedBy.desc ? '-' : ''}${sortedBy.field}` : null
export const getSearchText = (filter, text) => filter.id ? text || null : null

export const templateCriteria = (field = '', operator = '', value = '') => ({
  relationship: {
    label: 'LEI Records',
    id: 'FILTER_LEIREC',
  },
  field,
  fields: [],
  operator: field && field.operators ? field.operators[0] : '',
  operators: field && field.operators ? field.operators : [],
  dataType: 'STRING',
  value,
})

export const criteriaForUrl = (criteria) => {
  return criteria.map(({ relationship: { id, }, value, operator, field, dataType, }) => {
    return {
      relId: id,
      fieldId: field ? field.id : '',
      value,
      operator,
      dataType,
    }
  })
}

export const parseCriteriaFromUrl = ({ filters, relationships, }, criteria) => {
  return criteria.map(({ relId, fieldId, value, operator, dataType, }) => {
    const field = fieldId ? findFilterById(filters, fieldId) : ''
    const relationship = relationships.find((r) => r.id === relId) || {
      label: 'LEI Records',
      id: 'FILTER_LEIREC',
    }
    return {
      relationship,
      field,
      fields: getItemsByContext(filters, fieldId) || [],
      operator: operator || (field && field.operators ? field.operators[0] : ''),
      operators: field && field.operators ? field.operators : [],
      dataType: dataType || 'STRING',
      value,
    }
  })
}




// WEBPACK FOOTER //
// ./src/store/modules/search/helpers.js